import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../../interfaces/store/appStore';
import { AuthCardInlineFooter, AuthLink } from '../authFormCommon';

interface IAuthSignUpLoginPromptProps {
    inviteCode?: string;
}

const AuthSignUpLoginPrompt: React.FC<IAuthSignUpLoginPromptProps> = ({ inviteCode }) => {
    const navigate = useNavigate();
    const signInPath = inviteCode
        ? `${AppRoutes.SIGNIN}?invite=${encodeURIComponent(inviteCode)}`
        : AppRoutes.SIGNIN;

    return (
        <AuthCardInlineFooter>
            <BoldText>Already have an account?</BoldText>{' '}
            <AuthLink onClick={() => navigate(signInPath)}>Log in</AuthLink>
        </AuthCardInlineFooter>
    );
};

const BoldText = styled.span`
    font-weight: 700;
`;

export default AuthSignUpLoginPrompt;
